import { Component, inject, input, output } from '@angular/core'
import { CommonModule } from '@angular/common'
import { IAsset } from 'src/app/core/interfaces/asset.interface'
import { EventService } from 'src/app/core/services/event.service'
import { CurrencyCode } from 'src/app/core/interfaces/currency.interface'
import { LegacyImageProcessorTypes } from 'src/app/core/interfaces/image.interface'
import { LegacyImageProcessorDirective } from 'src/app/core/directives/legacy-image-processor.directive'
import { AssetPricePipe } from 'src/app/core/pipes/asset-price.pipe'
import { IconButtonModule } from '../icon-button/icon-button.module'

@Component({
  selector: 'app-comparison-card',
  templateUrl: './comparison-card.component.html',
  styleUrls: ['./comparison-card.component.scss'],
  imports: [
    CommonModule,
    LegacyImageProcessorDirective,
    AssetPricePipe,
    IconButtonModule,
  ],
})
export class ComparisonCardComponent {
  private _eventService = inject(EventService)
  contactForPricing = $localize`:@@asset-card.price-when-hidden:Contact for Pricing`

  asset = input<IAsset>()
  currencyCode = input<CurrencyCode>(CurrencyCode.USD)
  defaultImage = input<string>('')

  clearClicked = output<void>()

  LegacyImageServiceTypes = LegacyImageProcessorTypes
}
